import React, { useEffect, useRef, useState } from "react";


function Ukbusinessvisaimport() {
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRefs = useRef([]);
  const contentRef = useRef(null);
  const titleRef = useRef(null);

  useEffect(() => {
    sectionRefs.current = sectionRefs.current.slice(0, 5);

    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = sectionRefs.current.indexOf(entry.target);
          setActiveIndex(index);
        }
      });
    }, observerOptions);

    sectionRefs.current.forEach((section) => {
      if (section) observer.observe(section);
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  const scrollToSection = (index) => {
    setActiveIndex(index);
    const section = sectionRefs.current[index];
    const contentElement = contentRef.current;

    const scrollPosition = section.offsetTop - contentElement.offsetTop;

    contentElement.scrollTo({
      top: scrollPosition,
      behavior: "smooth",
    });
  };

  return (
    <>
      <div className="flex flex-wrap min-h-screen">
        {/* Sidebar Navigation */}
        <div
          ref={titleRef}
          className="sticky top-0 hidden h-screen w-1/4 bg-gray-100 p-6 overflow-y-auto md:block"
        >
          <ul className="space-y-4">
            <li
              onClick={() => scrollToSection(0)}
              className={`cursor-pointer p-4 ${
                activeIndex === 0
                  ? "bg-blue-500 text-white"
                  : "bg-white text-[#2C3F69]"
              } shadow rounded-md`}
            >
              Innovator Visa
            </li>
            <li
              onClick={() => scrollToSection(1)}
              className={`cursor-pointer p-4 ${
                activeIndex === 1
                  ? "bg-blue-500 text-white"
                  : "bg-white text-[#2C3F69]"
              } shadow rounded-md`}
            >
              Start-up Visa
            </li>
            <li
              onClick={() => scrollToSection(2)}
              className={`cursor-pointer p-4 ${
                activeIndex === 2
                  ? "bg-blue-500 text-white"
                  : "bg-white text-[#2C3F69]"
              } shadow rounded-md`}
            >
              Sole Representative Visa
            </li>
            <li
              onClick={() => scrollToSection(3)}
              className={`cursor-pointer p-4 ${
                activeIndex === 3
                  ? "bg-blue-500 text-white"
                  : "bg-white text-[#2C3F69]"
              } shadow rounded-md`}
            >
              Tier 1 (Investor) Visa
            </li>
            <li
              onClick={() => scrollToSection(4)}
              className={`cursor-pointer p-4 ${
                activeIndex === 4
                  ? "bg-blue-500 text-white"
                  : "bg-white text-[#2C3F69]"
              } shadow rounded-md`}
            >
              Business Visitor Visa
            </li>
          </ul>
        </div>

        {/* Content Section */}
        <div
          ref={contentRef}
          className="h-screen w-full overflow-y-auto bg-white p-6 md:w-3/4"
        >
          {/* Innovator Visa */}
          <div ref={(el) => (sectionRefs.current[0] = el)} className="mb-12">
            <p className="text-2xl font-bold text-[#011473]">Innovator Visa</p>
            <ul className="mt-4 list-disc pl-6 text-[#2C3F69]">
              <li>A minimum funding of £50,000 is required.</li>
              <li>Valid for an initial 3 years, with an option to extend.</li>
              <li>Eligibility for permanent residency after 5 years.</li>
            </ul>
          </div>

          {/* Start-up Visa */}
          <div ref={(el) => (sectionRefs.current[1] = el)} className="mb-12">
            <p className="text-2xl font-bold text-[#011473]">Start-up Visa</p>
            <ul className="mt-4 list-disc pl-6 text-[#2C3F69]">
              <li>No funding requirement, ideal for new entrepreneurs.</li>
              <li>Valid for 2 years, with the option to switch to an Innovator Visa.</li>
              <li>Requires support from a recognized endorsing organization.</li>
            </ul>
          </div>

          {/* Sole Representative Visa */}
          <div ref={(el) => (sectionRefs.current[2] = el)} className="mb-12">
            <p className="text-2xl font-bold text-[#011473]">
              Sole Representative Visa
            </p>
            <ul className="mt-4 list-disc pl-6 text-[#2C3F69]">
              <li>
                Enables businesses to set up a branch or subsidiary in the UK.
              </li>
              <li>Visa holders can bring dependents.</li>
              <li>Eligible for indefinite leave to remain after 5 years.</li>
            </ul>
          </div>

          {/* Tier 1 (Investor) Visa */}
          <div ref={(el) => (sectionRefs.current[3] = el)} className="mb-12">
            <p className="text-2xl font-bold text-[#011473]">
              Tier 1 (Investor) Visa
            </p>
            <ul className="mt-4 list-disc pl-6 text-[#2C3F69]">
              <li>Requires a minimum investment of £2 million.</li>
              <li>Initial visa valid for 3 years and 4 months, extendable.</li>
              <li>
                Offers a fast-track path to permanent residency based on investment.
              </li>
            </ul>
          </div>

          {/* Business Visitor Visa */}
          <div ref={(el) => (sectionRefs.current[4] = el)} className="mb-12">
            <p className="text-2xl font-bold text-[#011473]">
              Business Visitor Visa
            </p>
            <ul className="mt-4 list-disc pl-6 text-[#2C3F69]">
              <li>Typically valid for up to 6 months.</li>
              <li>Allows multiple visits during the validity period.</li>
              <li>
                Suitable for attending meetings, conferences and business engagements.
              </li>
            </ul>
          </div>
        </div>
      </div>

     




    </>
  );
}

export default Ukbusinessvisaimport;
